import { Card, CardActionArea, CardHeader, Grid, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import moment from "moment";
import { Class, Create, Delete, Language, MoreVert } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import './Training.css';
import image from '../../../assets/externaltraining.jfif'


function ExternalTrainingList(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [trainingId, setTrainingId] = useState(0);
    const [trainingName, setTrainingName] = useState("")

    const menuOpen = Boolean(anchorEl);

    const formatDate = (date) => {
        return moment(date).format('MMM-DD-YYYY');
    }
    const handleMenuClose = () => {
        setAnchorEl(null);
    }
    const handleMenu = (event, id, name) => {
        setAnchorEl(event.currentTarget);
        setTrainingId(id);
        setTrainingName(name)
    };
    const handleDelete = () => {
        setAnchorEl(null);
        props.handleDelete(trainingId, trainingName);
    }
    const handleEdit = () => {
        setAnchorEl(null);
        props.handleEdit(trainingId);
    }
    const handleDescription = (data) => {
        if (data === null || data === "" || data === undefined) {
            return "—"
        }
        else {
            return data.slice(0, 300);
        }
    }
    const handleClick = () => {
        // if (props.from !== "mylist") {
        props.handleAttendees(props.id)
        // }
    }
    return (
        <div className='training-box'>
            <Card sx={{ padding: 1, borderRadius: "10px", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;", marginBottom: "20px" }}>
                <Grid container spacing={1} sx={{ display: "flex",  borderRadius:"10px" }}>
                    <Grid item xs={2}>
                        <img src={image} className='training-img' alt="Courses" />
                    </Grid>
                    <Grid item xs={10} sx={{ padding: 1 }}>
                        <CardActionArea onClick={() => handleClick()}>
                            <h1 className="stensil training-title" style={{ fontWeight: "700",paddingRight:"3px" }}>{props.title}</h1>
                        </CardActionArea>
                       <div className='training-flex'>
                        <p className="stensil training-date" style={{ fontWeight: "bold", color: "#585858" }}><small><CalendarTodayIcon /> {formatDate(props.startDate)} to {formatDate(props.endDate)} </small>
                            {props.trainingType !== null && props.trainingType !== "" ? <span className='level-text stensil'>{props.trainingType === "Online" ? <Language /> : <Class />} {props.trainingType} </span> : <></>}
                        </p>
                        {props.from === "all"?
                        <p className="stensil training-date" style={{ fontWeight: "bold", color: "#585858" }}><small><Create /> Created by: {props.createrName} </small></p>
                        :""}
                        {props.from != "mylist" && props.attendees != null && props.attendees > 0?
                            <p className="stensil" style={{ color: "#113776", fontWeight: "bold", margin: "5px 0",float:"right" }}>Attendees: {props.attendees}</p> : ""}                       
                       </div>
                        <div className="stensil desc-training"><p>{handleDescription(props.description)}{props.description && props.description.length > 300 ? "..." : ""}</p></div>
                        <div className="stensil-ignore training-flex">
                            {props.externalTrainingType !== null && props.externalTrainingType !== "" ?
                                <p>
                                    {props.externalTrainingType === "Online" ?
                                        <span className='level-text stensil'><Language /> {props.externalTrainingType} </span> :
                                        <span className='level-text stensil'><Class /> {props.externalTrainingType} </span>}
                                </p> : ""}
                        </div>

                    </Grid>
                    {/* <Grid item xs={1}> */}
                    <div className='status stensil-ignore'>
                        {props.from !== "mylist" && props.from !== "all" ?
                            <IconButton sx={{ paddingRight: 1, float: "right" }} aria-label="settings"
                                aria-controls={menuOpen ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={menuOpen ? 'true' : undefined}
                                onClick={(e) => handleMenu(e, props.id, props.title)}>
                                <MoreVert />
                            </IconButton> : ""}
                        <Menu
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            className="common-menu-list"
                            open={menuOpen}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem className='common-menu-list-li' divider
                                onClick={() => handleEdit()}><EditIcon /> Edit</MenuItem>
                            <MenuItem className='common-menu-list-li'
                                onClick={() => handleDelete()}><Delete /> Delete</MenuItem>

                        </Menu>
                    {/* </Grid> */}
                    </div>
                </Grid>



            </Card>
        </div>
    )
}
export default ExternalTrainingList;